"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var R = _interopRequireWildcard(require("ramda"));
var _MediaCreator = _interopRequireDefault(require("./MediaCreator"));
var _EditMenu = _interopRequireDefault(require("./EditMenu"));
var _MediaObject = _interopRequireDefault(require("./MediaObject"));
var _icon = _interopRequireDefault(require("../icon"));
var _helpers = require("./helpers");
var _StyledMedia = require("./StyledMedia.style");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var Media = /*#__PURE__*/function (_Component) {
  _inherits(Media, _Component);
  var _super = _createSuper(Media);
  function Media(props) {
    var _this;
    _classCallCheck(this, Media);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "handleNewMediaCreator", function () {
      var _this$props = _this.props,
        data = _this$props.data,
        disabled = _this$props.disabled;
      var mediaLengthReached = R.length(data) >= 3;
      if (!mediaLengthReached && !disabled) {
        _this.setState(function (prevState) {
          return {
            newMediaCreatorOpen: !prevState.newMediaCreatorOpen,
            creatorOpen: prevState.newMediaCreatorOpen ? false : prevState.creatorOpen,
            mediaIndex: R.isNil(data) ? [] : R.length(data)
          };
        });
      }
    });
    _defineProperty(_assertThisInitialized(_this), "handleMediaCreatorPopup", function (mediaIndex) {
      _this.setState(function (prevState) {
        return {
          creatorOpen: !prevState.creatorOpen,
          editMenuOpen: !prevState.creatorOpen === true ? false : prevState.editMenuOpen,
          mediaIndex: mediaIndex,
          newMediaCreatorOpen: !prevState.creatorOpen === true ? false : prevState.newMediaCreatorOpen
        };
      });
    });
    _defineProperty(_assertThisInitialized(_this), "onMouseEnterHandler", function (index) {
      _this.setState(function (prevState) {
        return {
          showMoreIconIndex: prevState.creatorOpen ? null : index
        };
      });
    });
    _defineProperty(_assertThisInitialized(_this), "onMouseLeaveHandler", function () {
      _this.setState({
        showMoreIconIndex: null
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleMediaEditMenu", function (mediaIndex) {
      _this.setState(function (prevState) {
        return {
          editMenuOpen: !prevState.editMenuOpen,
          creatorOpen: !prevState.editMenuOpen === true ? false : prevState.creatorOpen,
          mediaIndex: R.isNil(mediaIndex) ? prevState.mediaIndex : mediaIndex
        };
      });
    });
    _defineProperty(_assertThisInitialized(_this), "onCreateLink", function (newLink) {
      var mediaIndex = _this.state.mediaIndex;
      var mediaList = R.isNil(_this.props.data) ? [] : _this.props.data;
      var isNewMediaItem = mediaIndex + 1 > R.length(mediaList) || R.isNil(mediaIndex);
      var updatedMediaList = isNewMediaItem ? [].concat(_toConsumableArray(mediaList), [newLink]) : mediaList.map(function (mediaItem, index) {
        if (index === mediaIndex) {
          return _objectSpread({}, newLink);
        }
        return mediaItem;
      });
      _this.setState({
        mediaIndex: null
      }, function () {
        _this.props.onChange(updatedMediaList);
      });
    });
    _defineProperty(_assertThisInitialized(_this), "onEditLink", function (mediaIndex) {
      _this.handleMediaEditMenu(mediaIndex);
      _this.handleMediaCreatorPopup(mediaIndex);
    });
    _defineProperty(_assertThisInitialized(_this), "onDeleteLink", function (mediaIndex) {
      _this.handleMediaEditMenu(mediaIndex);
      _this.setState({
        mediaIndex: null
      }, function () {
        var newMediaList = _this.props.data.filter(function (mediaItem, index) {
          return index !== mediaIndex;
        });
        _this.props.onChange(newMediaList);
      });
    });
    _this.state = {
      newMediaCreatorOpen: false,
      showMoreIconIndex: null,
      mediaIndex: null,
      creatorOpen: false,
      editMenuOpen: false
    };
    return _this;
  }
  _createClass(Media, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props2 = this.props,
        data = _this$props2.data,
        disabled = _this$props2.disabled,
        labels = _this$props2.labels,
        recommendedMediaSizes = _this$props2.recommendedMediaSizes,
        images = _this$props2.images,
        readOnly = _this$props2.readOnly,
        isDescriptionEmpty = _this$props2.isDescriptionEmpty,
        videoPlatformAccepted = _this$props2.videoPlatformAccepted;
      var _this$state = this.state,
        newMediaCreatorOpen = _this$state.newMediaCreatorOpen,
        mediaIndex = _this$state.mediaIndex,
        creatorOpen = _this$state.creatorOpen,
        showMoreIconIndex = _this$state.showMoreIconIndex,
        editMenuOpen = _this$state.editMenuOpen;
      var mediaIcon = images.mediaIcon,
        disabledMediaIcon = images.disabledMediaIcon,
        badImageURL = images.badImageURL;
      var mediaLengthReached = R.length(data) >= 3;
      return /*#__PURE__*/_react["default"].createElement(_StyledMedia.StyledMedia, {
        className: (0, _classnames["default"])({
          centered: readOnly && isDescriptionEmpty
        })
      }, newMediaCreatorOpen && /*#__PURE__*/_react["default"].createElement(_MediaCreator["default"], _extends({
        componentName: _helpers.MEDIA_COMPONENTS.MEDIA,
        onClose: this.handleNewMediaCreator,
        onChange: this.onCreateLink,
        labels: labels,
        recommendedMediaSizes: recommendedMediaSizes
      }, _helpers.defaultMediaProps, {
        videoPlatformAccepted: videoPlatformAccepted
      })), !readOnly && /*#__PURE__*/_react["default"].createElement(_StyledMedia.StyledMediaHandler, {
        onClick: this.handleNewMediaCreator,
        className: (0, _classnames["default"])({
          disabled: mediaLengthReached || disabled
        })
      }, /*#__PURE__*/_react["default"].createElement("img", {
        src: mediaLengthReached || disabled ? disabledMediaIcon : mediaIcon,
        alt: "media",
        className: "media-helper-icon"
      }), /*#__PURE__*/_react["default"].createElement("p", {
        className: "helper-text"
      }, labels.ADD_MEDIA)), !R.isEmpty(data) && !R.isNil(data) && /*#__PURE__*/_react["default"].createElement("div", {
        className: "media-list"
      }, data.map(function (mediaItem, index) {
        return (
          /*#__PURE__*/
          // eslint-disable-next-line react/no-array-index-key
          _react["default"].createElement("div", {
            key: "".concat(mediaItem.alt, "-").concat(index)
          }, /*#__PURE__*/_react["default"].createElement(_StyledMedia.StyledMediaContainer, {
            onMouseEnter: function onMouseEnter() {
              return _this2.onMouseEnterHandler(index);
            },
            onMouseLeave: _this2.onMouseLeaveHandler
          }, showMoreIconIndex === index && !disabled && /*#__PURE__*/_react["default"].createElement(_icon["default"], {
            className: "more-icon icon-ion-android-more-vertical ",
            size: 24,
            onClick: function onClick() {
              return _this2.handleMediaEditMenu(index);
            }
          }), editMenuOpen && mediaIndex === index && /*#__PURE__*/_react["default"].createElement(_EditMenu["default"], {
            onClose: function onClose() {
              return _this2.handleMediaEditMenu(index);
            },
            onEdit: function onEdit() {
              return _this2.onEditLink(index);
            },
            onDelete: function onDelete() {
              return _this2.onDeleteLink(index);
            }
          }), creatorOpen && mediaIndex === index && /*#__PURE__*/_react["default"].createElement(_MediaCreator["default"], _extends({
            componentName: _helpers.MEDIA_COMPONENTS.MEDIA,
            onClose: _this2.handleMediaCreatorPopup,
            onChange: _this2.onCreateLink,
            labels: labels,
            videoPlatformAccepted: videoPlatformAccepted
          }, data[mediaIndex])), /*#__PURE__*/_react["default"].createElement(_MediaObject["default"], {
            type: mediaItem.type,
            src: mediaItem.src,
            alt: mediaItem.alt,
            readOnly: readOnly,
            imageFallback: badImageURL,
            recommendedMediaSizes: recommendedMediaSizes[_helpers.MEDIA_COMPONENTS.MEDIA]
          })), mediaItem.alt && /*#__PURE__*/_react["default"].createElement("p", {
            className: "media-title"
          }, mediaItem.alt))
        );
      })));
    }
  }]);
  return Media;
}(_react.Component);
Media.defaultProps = {
  data: [],
  readOnly: false,
  recommendedMediaSizes: {},
  isDescriptionEmpty: false,
  videoPlatformAccepted: []
};
Media.propTypes = {
  readOnly: _propTypes["default"].bool,
  data: _propTypes["default"].arrayOf(_propTypes["default"].shape({})),
  onChange: _propTypes["default"].func.isRequired,
  disabled: _propTypes["default"].bool.isRequired,
  labels: _propTypes["default"].shape({
    ADD_MEDIA: _propTypes["default"].string
  }).isRequired,
  recommendedMediaSizes: _propTypes["default"].shape({}),
  images: _propTypes["default"].shape({
    mediaIcon: _propTypes["default"].string,
    disabledMediaIcon: _propTypes["default"].string,
    badImageURL: _propTypes["default"].string
  }).isRequired,
  isDescriptionEmpty: _propTypes["default"].bool,
  videoPlatformAccepted: _propTypes["default"].arrayOf(_propTypes["default"].string)
};
Media.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "handleNewMediaCreator",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "handleMediaCreatorPopup",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "mediaIndex",
      "type": null
    }],
    "returns": null
  }, {
    "name": "onMouseEnterHandler",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "index",
      "type": null
    }],
    "returns": null
  }, {
    "name": "onMouseLeaveHandler",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "handleMediaEditMenu",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "mediaIndex",
      "type": null
    }],
    "returns": null
  }, {
    "name": "onCreateLink",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "newLink",
      "type": null
    }],
    "returns": null
  }, {
    "name": "onEditLink",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "mediaIndex",
      "type": null
    }],
    "returns": null
  }, {
    "name": "onDeleteLink",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "mediaIndex",
      "type": null
    }],
    "returns": null
  }],
  "displayName": "Media",
  "props": {
    "data": {
      "defaultValue": {
        "value": "[]",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "shape",
          "value": {}
        }
      },
      "required": false
    },
    "readOnly": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "recommendedMediaSizes": {
      "defaultValue": {
        "value": "{}",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "shape",
        "value": {}
      },
      "required": false
    },
    "isDescriptionEmpty": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "videoPlatformAccepted": {
      "defaultValue": {
        "value": "[]",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "string"
        }
      },
      "required": false
    },
    "onChange": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": true
    },
    "disabled": {
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": true
    },
    "labels": {
      "description": "",
      "type": {
        "name": "shape",
        "value": {
          "ADD_MEDIA": {
            "name": "string",
            "required": false
          }
        }
      },
      "required": true
    },
    "images": {
      "description": "",
      "type": {
        "name": "shape",
        "value": {
          "mediaIcon": {
            "name": "string",
            "required": false
          },
          "disabledMediaIcon": {
            "name": "string",
            "required": false
          },
          "badImageURL": {
            "name": "string",
            "required": false
          }
        }
      },
      "required": true
    }
  }
};
var _default = Media;
exports["default"] = _default;